import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { gameMetaData, InventoryArticle, isSingle } from 'shared'
import { ExportCsv } from '../csv'

export interface OnboardingDownloadFetchedStockProps {
  handleNext: () => void
  setVisitedSteps: (value: React.SetStateAction<number[]>) => void
  fetchedStock: InventoryArticle[]
}

export const DownloadFetchedStock = ({
  fetchedStock,
}: OnboardingDownloadFetchedStockProps): JSX.Element => {
  const { t } = useTranslation()
  const [listOfFetchedStockSplittedByIdGame, setListOfFetchedStockSplittedByIdGame] = useState<{
    [key: number]: { stock: InventoryArticle[]; sealedStock: InventoryArticle[] }
  }>({})

  const getListOfDownloadsAccordingGame = (stock: InventoryArticle[]) => {
    const finalList: {
      [key: number]: { stock: InventoryArticle[]; sealedStock: InventoryArticle[] }
    } = {}

    stock.forEach((fetchedArticle) => {
      const key = fetchedArticle.card?.idGame || 0
      if (!finalList[key]) {
        if (isSingle(fetchedArticle.card)) {
          finalList[key] = {
            stock: [fetchedArticle],
            sealedStock: [],
          }
        } else {
          finalList[key] = {
            stock: [],
            sealedStock: [fetchedArticle],
          }
        }
      } else {
        if (isSingle(fetchedArticle.card)) finalList[key].stock.push(fetchedArticle)
        else {
          finalList[key].sealedStock.push(fetchedArticle)
        }
      }
    })

    setListOfFetchedStockSplittedByIdGame(finalList)
  }

  useEffect(() => {
    getListOfDownloadsAccordingGame(fetchedStock)
  }, [])

  return (
    <>
      <div className="d-flex justify-content-center w-100 pb-sm-10text-center">
        <div className="wizard-content container-small">
          <div className="container-sm mb-3">
            <div className="row">
              <div>
                <h4 className="mb-5 mt-5">{t('onboarding.exportStock')}</h4>
                <h4>{t('onboarding.exportStockTwo')}</h4>
                <div className="d-flex flex-wrap justify-content-center">
                  {Object.keys(listOfFetchedStockSplittedByIdGame).map((gameId) => {
                    const game = gameMetaData.find(({ idGame }) => idGame === (Number(gameId) || 0))

                    const { stock, sealedStock } = listOfFetchedStockSplittedByIdGame[game!.idGame]

                    const fetchedStock = [...stock, ...sealedStock]

                    return (
                      <div key={gameId} className="my-3 mx-3" style={{ width: '300px' }}>
                        <ExportCsv
                          stock={fetchedStock}
                          sealedStock={fetchedStock.filter((article) => isSingle(article.card))}
                          fetchedStockGame={game}
                          view={'onboarding'}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
